<script>
  import hotspotLogo from "../assets/img/hotspot.png";
  import back from "../assets/img/back.png";
  import blueCheck from "../assets/img/check_blue.png";
  import greenCheck from "../assets/img/check_green.png";
  import Gap from "./components/Gap.svelte";

  export let store;

  const baseURL = import.meta.env.VITE_BASE_URL;
  const portalURL = import.meta.env.VITE_BASE_PORTAL_URL;

  let errorMessage = null;

  let customerName = null;
  let description = null;

  let step = "TROUBLESHOOTING";

  function stepChange(stepNew) {
    step = stepNew;
  }

  function backButton() {
    if (step === "TICKET_CREATE") {
      step = "TROUBLESHOOTING";
    } else {
      store.setState("ACCOUNT");
    }
  }

  function dialNumber(number) {
    window.location.href = `tel:${number}`;
  }

  async function ticketSubmit() {
    if (description !== null) {
      console.log("Name:", customerName);
      console.log("Description:", description);

      try {
        let response = await fetch(`${baseURL}ticket/create/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobile_number: store.cellphone,
            description: description,
            customer_name: customerName,
          }),
        });

        if (response.status === 200) {
          step = "TICKET_SUBMITTED";
        } else {
          errorMessage = "Failed to submit ticket";
        }
      } catch (error) {
        errorMessage = "An error occured while submitting ticket";
      }
    } else {
      errorMessage = "Description cannot be blank";
    }
  }
</script>

<div class="w-full px-4 py-8">
  <div class="w-full mx-4">
    <button class="flex flex-row" on:click={backButton}>
      <img class="w-3" src={back} alt="Back button" />
      <div class="w-1"></div>
      <p class="text-[#5b95c8] text-md font-bold mx-2">Back</p>
    </button>
  </div>

  <div class="h-2"></div>

  <div class="mx-auto w-2/5">
    <img src={hotspotLogo} alt="TooMuchWifi hotspot logo" />
  </div>

  <Gap h="10"></Gap>

  {#if errorMessage}
    <div
      class="w-full mb-4 px-2 py-4 bg-red-500 text-center text-white p-4 rounded-md shadow-md transition-opacity duration-1000 ease-out"
    >
      {errorMessage}
    </div>
  {/if}

  {#if step === "TROUBLESHOOTING"}
    <h2 class="font-semibold">Here are some troubleshooting tips</h2>
    <Gap h="2"></Gap>
    <Gap h="2"></Gap>
    <div class="border border-gray-400 rounded-md px-2 py-4 space-y-2">
      <div class="flex flex-row">
        <img class="h-4 mr-3 my-auto" src={blueCheck} alt="Blue check" />
        <p class="text-sm my-auto">
          Verify that you are connected to a TooMuchWifi hotspot
        </p>
      </div>
      <div class="flex flex-row">
        <img class="h-4 mr-3 my-auto" src={blueCheck} alt="Blue check" />
        <p class="text-sm my-auto">Ensure that you have a hotspot voucher</p>
      </div>
      <div class="flex flex-row">
        <img class="h-4 mr-3 my-auto" src={blueCheck} alt="Blue check" />
        <p class="text-sm my-auto">
          Check signal strength, are you close enough to the hotspot?
        </p>
      </div>
      <div class="flex flex-row">
        <img class="h-4 mr-3 my-auto" src={blueCheck} alt="Blue check" />
        <p class="text-sm my-auto">Restart your device</p>
      </div>
    </div>

    <Gap h="10"></Gap>

    <div class="flex flex-col mx-auto text-center">
      <p class="font-medium">Still having issues?</p>

      <Gap h="2"></Gap>
      <Gap h="2"></Gap>
      <button
        class="bg-[#009946] text-white rounded-md py-2 font-medium"
        on:click={() => stepChange("TICKET_CREATE")}>Open a Ticket</button
      >
      <Gap h="2"></Gap>
      <button
        class="bg-[#1899d1] text-white rounded-md py-2 font-medium"
        on:click={() => dialNumber("0214355789")}>Call 0214355789</button
      >
    </div>
  {/if}

  {#if step === "TICKET_CREATE"}
    <form class="flex flex-col" on:submit|preventDefault={ticketSubmit}>
      <label class="font-medium">Name</label>
      <input
        class="border border-gray-400 rounded-md p-2"
        type="text"
        bind:value={customerName}
      />

      <Gap h="2"></Gap>

      <label class="font-medium">Describe your issue</label>
      <textarea
        class="border border-gray-400 rounded-md p-2 h-36"
        bind:value={description}
      />

      <Gap h="10"></Gap>

      <button
        class="bg-[#009946] text-white rounded-md py-2 font-medium"
        type="submit">Submit</button
      >
    </form>
  {/if}

  {#if step === "TICKET_SUBMITTED"}
    <div class="border border-gray-400 rounded-md px-4 py-8">
      <h2 class="font-semibold text-xl text-center">
        Thank you for submitting your ticket
      </h2>
      <Gap h="6"></Gap>
      <p class="text-gray-700 text-md text-center">
        A TooMuchWifi representative will be in contact with you
      </p>
      <Gap h="14"></Gap>
      <button
        class="text-[#009946] font-extrabold mx-auto w-full text-xl"
        on:click={backButton}>Done</button
      >
    </div>
  {/if}
</div>
